const Products = () => {
  return (
    <div className="container p-10 min-h-40 mt-20 m-auto">
      <div className="container md:w-3/6   m-auto">
        <h1 className="font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-wide break-words">
          GTT has developed{" "}
          <span className="text-indigo-600">Portable WiFi</span> and{" "}
          <span className="text-indigo-600">eSIM</span> solutions to distribute
          <span className="text-indigo-600">globally</span> not only for the
          inbound US customers but outbound and non-US related travels as well.
        </h1>
      </div>
    </div>
  );
};
export default Products;
